import * as React from 'react';
import { Link } from 'react-router-dom';
import { Groups } from '../../Enum/Groups';
import { UriBuilder } from '../../Service/UriBuilder';
import { Trans } from '../Trans';

interface GroupNavItemProps {
    group: Groups
    isActive: boolean
}

export class GroupNavItem extends React.PureComponent<GroupNavItemProps> {
    public render() {
        const props = this.props;
        const group = props.group;
        const uri = UriBuilder.groupUri(group);
        const className = 'pf-group-nav-item ' + (props.isActive ? '-active' : '-inactive');

        if (uri) {
            return <li className={className}><Link to={uri}><Trans id={'products.' + group}>{group}</Trans></Link></li>;
        } else {
            return null;
        }
    }
}
